



import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
    store,
    bus,
    client,
    checkAuth,
    toPascalCase,
    splitOnFirst,
    Authenticate,
} from '../shared';
import { redirect, Routes } from '../shared/router';
import { ActiveSession, UserInfo, ValidateAccessRequest } from '../shared/user';
@Component({
    components: {},
})
export default class Access extends Vue {
    /* ------------- Data -------------------- */

    /* ------------- Props ------------------- */

    /* ------------- Computed ---------------- */

    /* ------------- Methods ----------------- */

    /* ------------- Lifecycle Hooks --------- */
    get sessionId() {
        return this.$route.params.id;
    }
    async mounted() {
        try {
            const d = await client.post(
                new ValidateAccessRequest({ sessionId: this.$route.params.id }),
            );
            if (d.result) {
                const response = await client.post(
                    new Authenticate({
                        provider: 'credentials',
                        userName: d.username,
                        password: d.token,
                        rememberMe: true,
                    }),
                );
                bus.$emit('signin', response);
                const activeSession = await client.get(
                    new ActiveSession({ sessionId: this.$route.params.id }),
                );
                localStorage.setItem(
                    activeSession.result.userName,
                    JSON.stringify(activeSession.result),
                );
                const savedSession = JSON.parse(
                    localStorage.getItem(activeSession.result.userName) || '{}',
                );
                const userInfo = await client.get(
                    new UserInfo({ userName: d.username }),
                );
                bus.$set(store, 'userInfo', d);
                if (activeSession.result.dataProjectID !== 'Study') {
                    redirect(Routes.Data);
                } else {
                    redirect(Routes.Study);
                }
            } else {
                redirect(Routes.Home);
            }
        } catch (error) {
            redirect(Routes.Home);
        }
    }
}
